import React, { Component, Fragment } from 'react'
import { Tabs, TabList, TabPanel, Tab } from 'react-tabs';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getUserInfo } from "../../actions/user"
import { updateUserInfo } from "../../actions/updUserInfo";
import SimpleReactValidator from 'simple-react-validator';
// import Select from 'react-dropdown-select';
import { withRouter } from 'react-router-dom';

import {getGenderFilters} from '../../actions/filters';
import { updateEasyProfileMember,easyRewardsSearchMember, updateCapillaryProfileMember } from '../../actions/easyRewards';

var loading = <img src={require('../../assets/images/loader.gif')} width={20} height={20} alt="" />;

class UserInfo extends Component {
    constructor() {
        super()
        this.state = {
            cons_first_name: "",
            cons_last_name: "",
            cons_email_id: "",
            cons_dob: "",
            cons_gender: "",
        }
        this.validator = new SimpleReactValidator({
            messages: {
                regex: 'Enter Valid Email Address'
              },
              validators: {
                regex: {
                  message: 'Enter Valid Email Address',
                  rule: (val, params, validator) => {
                    return /^(("[\w\s]+")|([\w\.]+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val)


                    // /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(val);
                  },
                  messageReplace: (message, params) => message.replace(':values', params)
                }
              }
        });
    }

    async componentDidMount() {
        if(this.props.easyRewardsFlag === "Y"){
            const data = {
        mobile_no: localStorage.getItem('mobile_no'),
        token: this.props.configDetails?this.props.configDetails.Token : "",
      };
       let res =  await this.props.easyRewardsSearchMember(data);
        let dataAll = res.data.MemberResponse ? res.data.MemberResponse : {}

        this.setState({
            cons_first_name: dataAll && dataAll.FirstName,
            cons_last_name: dataAll && dataAll.LastName,
            cons_email_id:  dataAll &&  dataAll.Email,
            cons_dob: dataAll &&  dataAll.DateOfBirth,
        })
        }else{
            this.setState({
            cons_first_name: this.props.userDetails.COM_FNAME,
            cons_last_name: this.props.userDetails.COM_LNAME,
            cons_email_id:  this.props.userDetails.COM_EMAIL_ID,
            cons_dob: this.props.userDetails.COM_DOB,
        })
        }
         
        
       
    }

    handleBack = () => {
        this.props.history.goBack();
    }

    handleChange(event) {
        const fieldName = event.target.id;
  const fieldValue = event.target.value;
        this.setState({ [event.target.id]: event.target.value });
        this.validator.showMessageFor(fieldName);
    }

    handleGenderChange(value){
        
        this.setState({
            cons_gender : value[0].GEN_GENDER_CD
        })
    }

   async handleSubmit(event) {
    let {easyRewardsFlag,capillaryflag} = this.props
        event.preventDefault();
        if (this.validator.allValid()) {
            const { connection_id } = this.props
            const options = {
                connection_id,
                user_data: {
                    ...this.state,
                    cons_mobile_no: this.props.userDetails.COM_CONSUMER_MOBILE_NO
                }
            }
           if(easyRewardsFlag=== "Y"){
            let {configDetails,userDetails,store_details} = this.props
let data ={
        mobile_no:localStorage.getItem('mobile_no'),
        firstName:this.state.cons_first_name,
        username:'apiuser@BlissClub.com',
        store_code:store_details ? store_details.store_code : '' ,
        lastName:   this.state.cons_last_name ? this.state.cons_last_name : '',
        emailId: this.state.cons_email_id ? this.state.cons_email_id : '',  
        token: configDetails && configDetails.Token ? configDetails.Token : '',
        address1:userDetails.COM_ADDRESS1 ? userDetails.COM_ADDRESS1 : '', 
        address2:userDetails.COM_ADDRESS2 ? userDetails.COM_ADDRESS2 : '', 
        pinCode: userDetails.COM_PIN ? userDetails.COM_PIN : '',

      }
      await this.props.updateEasyProfileMember(data);
           }else if(capillaryflag == 'Y'){
            let {userDetails} =this.props;
            let data ={
        mobile_no:localStorage.getItem('mobile_no'),
        firstName:this.state.cons_first_name,
        connection_id:connection_id,      
        lastName:   this.state.cons_last_name ? this.state.cons_last_name : '',
        emailId: this.state.cons_email_id ? this.state.cons_email_id : '',
         address1: userDetails.COM_ADDRESS1,
          address2: userDetails.COM_ADDRESS2,
          address3: userDetails.COM_ADDRESS3,
          stateName: userDetails.COM_STATE_NAME,
          countryName: userDetails.COM_CONTRY_NAME,
          townName: userDetails.COM_TOWN_NAME,
          pinCode: userDetails.COM_PIN,
          dob : this.state.cons_dob ? this.state.cons_dob:''
      }
      await this.props.updateCapillaryProfileMember(data); 
           }
            this.props.updateUserInfo(options)
            setTimeout(() => {
                this.props.history.goBack()
            }, 3000)
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    
   

    render() {
        
        // const {genderFilter} = this.props
        return (
            <Fragment>
                <section className="tab-product m-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 col-lg-12">
                                <Tabs className="tab-content nav-material"  style={{padding:15}}>
                                    <TabList className="nav nav-tabs nav-material">
                                        <Tab className="nav-item">
                                            <span className="nav-link" style={{fontSize:18,fontWeight:'bold'}} >
                                                <i className="icofont icofont-contacts"></i>User Profile</span>
                                            <div className="material-border"></div>
                                        </Tab>
                                    </TabList>
                                    <TabPanel>
                                        <form className="theme-form mt-4" onSubmit={(e) => this.handleSubmit(e)}>
                                            <div className="form-row">
                                                <div className="col-md-6">
                                                    <label htmlFor="name">First Name</label>
                                                    <input className="form-control" type="text" id="cons_first_name"
                                                        defaultValue={this.props.userDetails.COM_FNAME} 
                                                        onChange={(e) => this.handleChange(e)} autocomplete="new"/>
                                                    {this.validator.message('first name', this.state.cons_first_name, 'required|alpha_space')}
                                                </div>
                                                <div className="col-md-6">
                                                    <label htmlFor="email">Last Name</label>
                                                    <input className="form-control" type="text" id="cons_last_name"
                                                        defaultValue={this.props.userDetails.COM_LNAME} onChange={(e) => this.handleChange(e)} autocomplete="new"/>
                                                    {/* {this.validator.message('last name', this.state.cons_last_name, 'required|alpha')} */}
                                                </div>
                                                <div className="col-md-6">
                                                    <label htmlFor="review">Email</label>
                                                    <input className="form-control" type="text" id="cons_email_id"
                                                        defaultValue={this.props.userDetails.COM_EMAIL_ID} onChange={(e) => this.handleChange(e)} autocomplete="new"/>
                                                    {/* {this.validator.message('email', this.state.cons_email_id, 'required|email')} */}
                                                    {this.validator.message(              'cons_email_id',
              this.state.cons_email_id,
              'required|regex',{
                messages: {
                //   required: 'Please provide a Email.',
              },
              }
            )}
                                                </div>
                                                <div className="col-md-6">
                                                    <label htmlFor="review">Mobile No</label>
                                                    <input className="form-control" type="text" id="cons_mobile_no"
                                                        value={this.props.userDetails.COM_CONSUMER_MOBILE_NO} readOnly />
                                                </div>
                                                <div className="col-md-6">
                                                    <label htmlFor="review">Date Of Birth</label>
                                                    <input className="form-control"  type="date" id="cons_dob"  max={new Date().toISOString().split('T')[0]}
                                                        defaultValue={this.props.userDetails.COM_DOB ? new Date(this.props.userDetails.COM_DOB).toLocaleDateString('en-CA') : new Date('DD-MM-YYYY') } onChange={(e) => this.handleChange(e)} />
                                                </div>
                                                <div className="col-md-6">
                                                    {/* <label htmlFor="review">Gender</label> */}
                                                    {/* <input className="form-control" type="text" id="cons_gender"
                                                        value={this.props.userDetails.COM_GENDER_DESC} readOnly /> */}
                                                        {/* <select className="form-control" id="cons_gender">
                                                             <option value={'ME'}>Men</option>
                                                             <option value={'Wo'}>Women</option>
                                                        </select> */}
                                                        {/* <Select
                                                            loading={genderFilter.loading}
                                                            searchable={false}
                                                            labelField='GEN_GENDER_NAME'
                                                            valueField='GEN_GENDER_CD'
                                                            keepSelectedInList={false}
                                                            options={genderFilter.data}
                                                           placeholder={this.props.userDetails.COM_GENDER_DESC || ''}
                                                            values={[]}
                                                            onChange={(values) => this.handleGenderChange(values)}
                                                        /> */}
                                                </div>
                                                <div className="col-md-12" style={{paddingBottom:100}} >
                                                    <div className="pull-right">
                                                        <button type="button" className="btn btn-solid" style={{ marginRight: 10 }}
                                                            onClick={() => this.handleBack()}
                                                        >Back</button>
                                                        <button type="submit" className="btn btn-solid" disabled={this.props.updatingUser}>{this.props.updatingUser ? loading : 'Save'}</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </TabPanel>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </section>
            </Fragment>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    isAuth: state.user.isAuth,
    userDetails: state.user.user_details,
    connection_id: state.tenant.connection_id,
    updatingUser: state.updateUser.loading,
    memberDetails:state.easyRewards.memberDetails,
    store_details: state.tenant.store_details,
     configDetails: state.tenant.configDetails,
     easyRewardsFlag: state.tenant.tenant_details.easy_rewards_flg || "N",
     capillaryflag : state.tenant.tenant_details.capillary_flg || "N"
     
    // genderFilter: state.filters.gender
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { getUserInfo, updateUserInfo,updateCapillaryProfileMember,updateEasyProfileMember,easyRewardsSearchMember, getGenderFilters },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(UserInfo));
